// Import dependencies
import { format, isValid } from 'date-fns';
import { initialiser } from '../../ramen-imports/utilitybelt';

class Datetime {
  constructor(config) {
    const { el } = config;

    // Set module dom elements
    this.container = el;
    this.date = this.container.dataset.date ? new Date(this.container.dataset.date) : new Date();
    this.format = this.container.dataset.format || 'dd/MM/yyyy';
  }

  // Initialisation Function
  init = () => {
    if (isValid(this.date)) {
      this.container.innerHTML = format(this.date, this.format);
    } else {
      this.container.innerHTML = 'Error: Datetime component date is invalid';
    }
  };
}

export default (settings) => initialiser(settings, Datetime);
